import messages from '@smartmixin/i18n/dist/translations/tr.json';

export default messages;
